import {
	CommandPayload,
	FlowDeploymentState,
	GetDeployStatePath,
	StopRunPath,
	StopRunPayload,
	urlCombine,
} from 'ihub/common';
import {
	isURLSet,
	microTaskRunnerAPI,
	standardGet,
	standardPost,
	validateOkResponse,
} from '../classes/http-helper-const';

export class TaskExecutorHttpService {
	simulateIntegrationPath = 'simulateIntegration';

	async simulateIntegration(integrationID: string, data: CommandPayload) {
		isURLSet();
		const url = urlCombine(
			microTaskRunnerAPI,
			`${this.simulateIntegrationPath}?IntegrationID=${integrationID}`
		);
		const response = await standardPost(url, { data });
		await validateOkResponse(response, 'simulate integration', 'Simulate Integration');
		return await response.clone().json();
	}

	async getDeployState(id: string): Promise<{ state: FlowDeploymentState }> {
		isURLSet();
		const url = urlCombine(microTaskRunnerAPI, GetDeployStatePath, id);
		const response = await standardGet(url);
		await validateOkResponse(response, 'get deploy state', 'Deployment State');
		return await response.clone().json();
	}

	async stopRun(stopRunPayload: StopRunPayload) {
		isURLSet();
		const url = urlCombine(microTaskRunnerAPI, StopRunPath);
		const response = await standardPost(url, stopRunPayload);
		return await validateOkResponse(response, 'Stop Run', 'Stop Run');
	}
}
